import dayjs from "dayjs"

/**
 * Adds (or subtracts) months from a date, working around a dayjs-tz bug
 * where `.add(n, "month")` can drift across month boundaries during DST
 * transitions. The dayjs-tz plugin does not override `add`, so month
 * arithmetic uses raw UTC setMonth which can land on the wrong side of
 * midnight when the UTC offset changes between the source and target months.
 *
 * The fix: move to the 15th before adding so no timezone conversion can
 * push the result into an adjacent month.
 *
 * @param {import("dayjs").Dayjs | Date | string} date - a date value
 * @param {number} months - number of months to add (negative to subtract)
 * @returns {import("dayjs").Dayjs}
 */
export function addMonths(date, months) {
  const d = dayjs.isDayjs(date) ? date : dayjs(date)
  return d.date(15).add(months, "month")
}
